﻿import { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { Row, Col, Form, Modal, Button } from "react-bootstrap";
import { useToasts } from "react-toast-notifications";
import Select from "react-select";

import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import { toast, validRoles } from "@/services/Utils";

import classes from "../../maintainers.module.scss";
import Fetching from "@/components/Fetching/Fetching";

import { base_incident } from "../incidents.constants";
import api from "@/services/api.service";

import { NoOptionsMessage } from "@/components/ReactSelect/NoOptions";

const IncidentsForm = ({ customers, confirmSave }) => {
	const { addToast } = useToasts();
	const location = useLocation();
	const { option, selected } = useParams();
	const navigate = useNavigate();

	const [isFetching, setIsFetching] = useState(true);
	const [loadImage, setLoadImage] = useState(false);
	const [data, setData] = useState({ ...base_incident });

	const userRoles = JSON.parse(localStorage.getItem("roles"));
	const isAdmin = validRoles(userRoles, ["administrador"]);

	const handleClose = () => {
		emptyFields();
		if (location.state) {
			navigate(location.state);
			return;
		}

		navigate("/mantenedores/incidencias");
	};

	const validSave = () => {
		if (!data.title) {
			toast(addToast, "Debe ingresar un título para guardar.", "error");
			return false;
		}

		if (!data.description) {
			toast(addToast, "Debe ingresar una descripción.", "error");
			return false;
		}

		return true;
	};

	const handleSave = () => {
		if (validSave()) {
			confirmSave({ form: data }, setIsFetching, afterSave);
		}
	};

	const emptyFields = () => {
		setData({ ...base_incident });
	};

	const afterSave = () => {
		handleClose();
		addToast("Incidencia guardada correctamente.", {
			appearance: "success",
		});
	};

	useEffect(() => {
		setIsFetching(true);
		if (option && selected) {
			api.get("/admin/incidents/detail", { selected }).then((response) => {
				const { detail } = response;
				if (detail) {
					setData(detail);
				} else {
					addToast("Ocurrió un problema al cargar la incidencia seleccionada.", {
						appearance: "error",
					});
					handleClose();
				}
				setIsFetching(false);
			});
		} else {
			setIsFetching(false);
		}
		// eslint-disable-next-line
	}, [selected, option]);

	const handleDescription = (event, editor) => {
		const text = editor.getData();
		setData({ ...data, description: text ? text : "" });
	};

	const handleSolution = (event, editor) => {
		const text = editor.getData();
		setData({ ...data, solution: text ? text : "" });
	};

	function uploadAdapter(loader) {
		return {
			upload: () => {
				return new Promise((resolve, _reject) => {
					const body = new FormData();
					body.append("related_table", "incidents");
					body.append("external_id", null);
					loader.file.then((file) => {
						body.append("files[]", file);
						setLoadImage(true);
						api.post("/client/files/upload_file", body).then((response) => {
							setLoadImage(false);
							resolve({
								default: response.url,
							});
						});
					});
				});
			},
		};
	}

	function uploadPlugin(editor) {
		editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
			return uploadAdapter(loader);
		};
	}

	return (
		<Modal
			show={option && option === "editar" ? true : false}
			onHide={handleClose}
			backdrop="static"
			keyboard={false}
			className={classes.main_form}
			size="lg"
		>
			<Modal.Header closeButton>
				<h4 className={classes.modal_title}>Incidencia</h4>
			</Modal.Header>

			<Modal.Body>
				{isFetching ? (
					<Fetching topMargin={"1em"} />
				) : (
					<Row className={classes.row_form}>
						<Col md={12} xs={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Título</Form.Label>
								<Form.Control
									value={data.title ? data.title : ""}
									onChange={(e) =>
										setData({
											...data,
											title: e.currentTarget.value,
										})
									}
									type="text"
								/>
							</Form.Group>
						</Col>
						<Col md={12} xs={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Descripción</Form.Label>
								<CKEditor
									editor={ClassicEditor}
									onChange={handleDescription}
									data={data && data.description ? data.description : ""}
									config={{
										extraPlugins: [uploadPlugin],
										mediaEmbed: {
											previewsInData: true,
										},
									}}
								/>
							</Form.Group>
						</Col>
						<Col md={12} xs={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Solución</Form.Label>
								<CKEditor
									editor={ClassicEditor}
									onChange={handleSolution}
									data={data && data.solution ? data.solution : ""}
									config={{
										extraPlugins: [uploadPlugin],
										mediaEmbed: {
											previewsInData: true,
										},
									}}
								/>
							</Form.Group>
						</Col>
						<Col md={12} xs={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Clientes</Form.Label>
								<Select
									isMulti
									value={data.customer_id ? customers.filter((c) => data.customer_id.includes(c.value)) : []}
									placeholder={<div>Clientes</div>}
									options={customers}
									onChange={(value) => {
										let newCustomers = [];

										value.forEach((customer) => {
											newCustomers.push(customer.value);
										});

										setData({
											...data,
											customer_id: newCustomers,
										});
									}}
									components={{
										NoOptionsMessage,
									}}
								/>
							</Form.Group>
						</Col>
					</Row>
				)}
			</Modal.Body>
			<Modal.Footer>
				{isAdmin && !isFetching && (
					<Button variant="success" onClick={handleSave} disabled={loadImage}>
						{loadImage ? "GUARDANDO FOTOS" : "GUARDAR"}
					</Button>
				)}
			</Modal.Footer>
		</Modal>
	);
};

export default IncidentsForm;
